(function () {
	document.addEventListener("DOMContentLoaded", () => {
		const isTablet = document.cookie.split(';').some(function (c) { return c.trim() === 'vg_tablet_mode=true'; });
		if (!isTablet) return;

		const isJoiningPage = /\/joining-\d\//.test(window.location.pathname);
		if (isJoiningPage) return;

		const cookieEntry = document.cookie.split(';').find(function (c) { return c.trim().startsWith('vg_tablet_joining_url='); });
		if (!cookieEntry) return;

		const backUrl = decodeURIComponent(cookieEntry.trim().split('=').slice(1).join('='));
		if (!backUrl) return;

		const btn = document.getElementById('vg-tablet-back-btn');
		if (!btn) return;

		btn.href = backUrl;
		btn.style.display = 'flex';
	});
})();